import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/switch/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h2>{`Summary`}</h2>
    <p>{`Switches on iOS are implemented with the built-in UIKit component `}<inlineCode parentName="p">{`UISwitch`}</inlineCode>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/switch_on.png",
        "alt": "iOS switch (on)"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "/img/ios/switch_off.png",
        "alt": "iOS switch (off)"
      }}></img></p>
    <h2>{`Public API`}</h2>
    <p>{`See Apple documentation on `}<a parentName="p" {...{
        "href": "https://developer.apple.com/documentation/uikit/uiswitch"
      }}>{`UISwitch`}</a>{` for the public API.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      